import styles from './ErrorFallbackPage.module.scss';

/**
 * Fallback UI shown when a top-level error boundary catches an unrecoverable error.
 */
export function ErrorFallbackPage() {
  const handleReload = () => {
    window.location.href = '/promote';
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>Something went wrong</h1>
        <p className={styles.description}>
          An unexpected error occurred. Please try refreshing the page.
        </p>
        <button className={styles.button} onClick={handleReload} type="button">
          Return to Dashboard
        </button>
      </div>
    </div>
  );
}
